import React, { useMemo } from 'react';
import './AlienMessage.css';

interface AlienMessageProps {
  onDismiss?: () => void;
}

const messages = [
  { text: "Hey there, space cadet!", emoji: "👋" },
  { text: "Taking a break? We'll keep watch!", emoji: "🛸" },
  { text: "Don't forget to hydrate, human!", emoji: "💧" },
  { text: "You're doing great!", emoji: "🌟" },
  { text: "We come in peace... and snacks!", emoji: "🍪" },
  { text: "Miss you already! Come back soon!", emoji: "💜" },
  { text: "Houston, we have a breather!", emoji: "🚀" },
  { text: "Time for a quick orbit around the kitchen?", emoji: "🌍" },
  { text: "Your productivity is out of this world!", emoji: "✨" },
  { text: "Stretch those human limbs!", emoji: "🧘" },
  { text: "Beep boop! Break time detected!", emoji: "🤖" },
  { text: "The stars align for a coffee break!", emoji: "☕" },
];

const AlienMessage: React.FC<AlienMessageProps> = ({ onDismiss }) => {
  const message = useMemo(() => {
    const randomIndex = Math.floor(Math.random() * messages.length);
    return messages[randomIndex];
  }, []);

  return (
    <div className="alien-message" onClick={onDismiss}>
      <div className="alien-message-bubble">
        <span className="alien-message-emoji">{message.emoji}</span>
        <p className="alien-message-text">{message.text}</p>
      </div>
      <div className="alien-message-tail" />
    </div>
  );
};

export default AlienMessage;
